module.exports = __webpack_public_path__ + "static/media/0028.36247b8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48012/RAL/0028.png
// module id = 634
// module chunks = 0